"use strict";

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackTiming;

var _react = require("react");

var _createCustomEvent = _interopRequireDefault(require("../Utils/createCustomEvent"));

var _randomId = _interopRequireDefault(require("../Utils/randomId"));

var _useReadTelemetryDimensions = _interopRequireDefault(require("./internal/useReadTelemetryDimensions"));

var _useTrackException = _interopRequireDefault(require("./useTrackException"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function useTrackTiming() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      onTelemetry = _useWebChatUIContext.onTelemetry;

  var readTelemetryDimensions = (0, _useReadTelemetryDimensions.default)();
  var trackException = (0, _useTrackException.default)();
  return (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, functionOrPromise) {
      var timingId, startTime, duration;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!name || typeof name !== 'string')) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", console.warn('botframework-webchat: "name" passed to "useTrackTiming" hook must be specified and of type string.'));

            case 4:
              if (!(typeof functionOrPromise !== 'function' && typeof functionOrPromise.then !== 'function')) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", console.warn('botframework-webchat: "functionOrPromise" passed to "useTrackTiming" hook must be specified, of type function or Promise.'));

            case 6:
              timingId = (0, _randomId.default)();
              onTelemetry && onTelemetry((0, _createCustomEvent.default)('timingstart', {
                dimensions: readTelemetryDimensions(),
                name: name,
                timingId: timingId
              }));
              startTime = Date.now();
              _context.prev = 9;
              _context.next = 12;
              return typeof functionOrPromise === 'function' ? functionOrPromise() : functionOrPromise;

            case 12:
              return _context.abrupt("return", _context.sent);

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](9);
              trackException(_context.t0, false);
              throw _context.t0;

            case 19:
              _context.prev = 19;
              duration = Date.now() - startTime;
              onTelemetry && onTelemetry((0, _createCustomEvent.default)('timingend', {
                dimensions: readTelemetryDimensions(),
                duration: duration,
                name: name,
                timingId: timingId
              }));
              return _context.finish(19);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 15, 19, 23]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [onTelemetry, readTelemetryDimensions, trackException]);
}